import { OktaAuth } from "@okta/okta-auth-js";

/** `pnpm preview` runs the UI against the in-memory preview API with no Okta.
 *  Dev-server only: `import.meta.env.DEV` is false in a production build, so
 *  this flag compiles to false there and VITE_AUTH_MODE cannot disable sign-in. */
export const PREVIEW_AUTH: boolean = import.meta.env.DEV && import.meta.env.VITE_AUTH_MODE === "preview";

/** The preview API accepts any bearer token; the header itself is still required. */
export const PREVIEW_TOKEN = "preview";

export const oktaAuth: OktaAuth | null = PREVIEW_AUTH
  ? null
  : new OktaAuth({
      issuer: import.meta.env.VITE_OKTA_ISSUER,
      clientId: import.meta.env.VITE_OKTA_CLIENT_ID,
      redirectUri: window.location.origin + "/login/callback",
      scopes: ["openid", "profile", "email"],
      pkce: true,
    });

/** The Authorization bearer for an API call: Okta's access token, or the
 *  preview stand-in when the UI is running without a tenant. */
export async function getBearerToken(): Promise<string | null> {
  if (!oktaAuth) return PREVIEW_TOKEN;
  return (await oktaAuth.getAccessToken()) ?? null;
}
